import { useBuild } from "~/components/build/Show/lib/BuildContext";
import V2TestEngine from "~/components/build/Show/V2TestEngine";
import { Navigate } from "react-router-dom";
import classNames from "classnames";

export default function Tests() {
  const { build } = useBuild();
  const buildSidebarDisabled = !Features.BuildSidebar;

  if (!build.testEngine.testTabUrl) {
    return <Navigate to={build.path} replace={true} />;
  }

  return (
    <div
      className={classNames("relative min-w-0 flex-auto contain-layout", {
        "-mt-3": buildSidebarDisabled,
      })}
    >
      <div className="absolute h-full w-full overflow-y-auto rounded-b-md bg-white">
        <V2TestEngine build={build} />
      </div>
    </div>
  );
}
